export default __webpack_public_path__ + "static/media/FB_MessengerAddCallbackUrl.a8acf359.png";